import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { devTools } from '@ngneat/elf-devtools';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare let window: any;

if (!window.timechefNotRunnable) {
  if (environment.enableAngularProdMode) enableProdMode();

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
      devTools({
        postTimelineUpdate: () => moduleRef.injector.get(ApplicationRef).tick(),
      });
    })
    .catch((err) => console.log(err));
} else {
  console.log(' prompt  to old site');
}
